export default function() {
  return navigator.userAgent.toLowerCase().includes("samsungbrowser")
}
